import VisitItem from './VisitItem';
import style from './Visits.module.scss';
import { Visit } from '@ax/redux-store';
import { NOTE_STATUS } from '@ax/constants';

export interface VisitListProps {
  items: Visit[];
  onVisitItemClick: (visitItem?: Visit) => void;
  selectedVisit: string | undefined;
  setDefaultVisit?: () => void;
  readonly?: boolean;
}

const VisitList = ({
  items,
  onVisitItemClick,
  selectedVisit,
  readonly,
}: VisitListProps) => {
  return (
    <ul className={style.visit__list}>
      {items?.map((item, index) => {
        const noteStatus = item.isProcessing ? NOTE_STATUS.CONTENT_PROCESSING : item.noteStatus;

        return (
          <VisitItem
            key={index}
            {...item}
            noteStatus={noteStatus}
            selected={item.uuid === selectedVisit}
            onClick={() => onVisitItemClick(item)}
            readonly={readonly}
          />
        );
      })}
    </ul>
  );
};

export default VisitList;
